var map = {
	"./arablau/logo-head.png": 8083,
	"./dicas/logo-head.png": 2072,
	"./ghgorbis/logo-head.png": 6428,
	"./inpacs/logo-head.svg": 6874,
	"./maripol/logo-head.png": 2223,
	"./orbishigiene/logo-head.png": 6929,
	"./pedrosa/logo-head.png": 4341,
	"./prisma/logo-head.png": 3680,
	"./vario/logo-head.png": 4541,
	"./vario/logo-head.svg": 2834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2557;